<template>
  <div class="flex row my2 justify_between">
    <div class="flex">
      <div
        class="online_status"
        :style="`background-color: ${$CONSTANTS.onlineStatuses[1].color}`"
      />

      <img
        :src="user.image.url"
        :width="72"
        :height="72"
        class="thumbnail"
      />

      <h4 class="mya pl2">
        <b>{{ user.fullName }}</b>
      </h4>
    </div>

    <slot/>
  </div>
</template>

<script>
import store from '@/store';

export default {
  name: 'user',

  data() {
    return {
      user: store.state.user,
    };
  },

  created() {
    if (!this.user.image) {
      this.user.image = {};
    }
  },
};
</script>
